 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Scan~Setting~add-company-intro-template~brand-Creator~edit-coupon~edit-notification~edit-sale~forget~363e6f6e":"Scan~Setting~add-company-intro-template~brand-Creator~edit-coupon~edit-notification~edit-sale~forget~363e6f6e","Scan~Setting~add-company-intro-template~brand-Creator~edit-coupon~edit-notification~edit-sale~forget~fe0fad14":"Scan~Setting~add-company-intro-template~brand-Creator~edit-coupon~edit-notification~edit-sale~forget~fe0fad14","Scan~forget-password~login~reset-password~sign-up~sub-merchant-login":"Scan~forget-password~login~reset-password~sign-up~sub-merchant-login","Scan":"Scan","forget-password":"forget-password","login":"login","reset-password":"reset-password","sent~sign-up":"sent~sign-up","sign-up":"sign-up","sub-merchant-login":"sub-merchant-login","brand-Creator":"brand-Creator","Setting~add-company-intro-template~edit-coupon~edit-notification~edit-sale~home~list-company-intro-t~7c0eb344":"Setting~add-company-intro-template~edit-coupon~edit-notification~edit-sale~home~list-company-intro-t~7c0eb344","Setting~add-company-intro-template~edit-coupon~edit-notification~edit-sale~home~list-company-intro-t~ef0237b1":"Setting~add-company-intro-template~edit-coupon~edit-notification~edit-sale~home~list-company-intro-t~ef0237b1","Setting":"Setting","add-company-intro-template":"add-company-intro-template","edit-coupon":"edit-coupon","edit-notification":"edit-notification","edit-sale":"edit-sale","list-coupons":"list-coupons","sub-merchant":"sub-merchant","list-merchants~list-notification~list-sales~list-statistics~qr-scanner-list-scanned-coupons~qrcode-order":"list-merchants~list-notification~list-sales~list-statistics~qr-scanner-list-scanned-coupons~qrcode-order","list-merchants":"list-merchants","list-notification":"list-notification","list-sales":"list-sales","list-statistics":"list-statistics","qr-scanner-list-scanned-coupons":"qr-scanner-list-scanned-coupons","qrcode-order":"qrcode-order","home":"home","list-company-intro-template":"list-company-intro-template","qrcode-order-detail":"qrcode-order-detail","auth":"auth","community":"community","help":"help","sent":"sent","tnc":"tnc","welcome":"welcome"}[chunkId]||chunkId) + "." + {"Scan~Setting~add-company-intro-template~brand-Creator~edit-coupon~edit-notification~edit-sale~forget~363e6f6e":"1be7fa8f","Scan~Setting~add-company-intro-template~brand-Creator~edit-coupon~edit-notification~edit-sale~forget~fe0fad14":"3765a076","Scan~forget-password~login~reset-password~sign-up~sub-merchant-login":"97298f3b","Scan":"c095de3f","forget-password":"0ebe0438","login":"ab1e4e05","reset-password":"85a93cce","sent~sign-up":"da78eb57","sign-up":"691ac0d6","sub-merchant-login":"3b21c87c","brand-Creator":"47bdd171","Setting~add-company-intro-template~edit-coupon~edit-notification~edit-sale~home~list-company-intro-t~7c0eb344":"bb3e84d8","Setting~add-company-intro-template~edit-coupon~edit-notification~edit-sale~home~list-company-intro-t~ef0237b1":"703c16b5","Setting":"b25545b1","add-company-intro-template":"12fd211a","edit-coupon":"a5613aba","edit-notification":"db3595f8","edit-sale":"eee9dd70","list-coupons":"54092ba4","sub-merchant":"e2993487","list-merchants~list-notification~list-sales~list-statistics~qr-scanner-list-scanned-coupons~qrcode-order":"974725fb","list-merchants":"51353266","list-notification":"bd43fef3","list-sales":"8fabf03a","list-statistics":"9db1fe91","qr-scanner-list-scanned-coupons":"f0506f6a","qrcode-order":"24324a12","home":"68631f00","list-company-intro-template":"8586bd6a","qrcode-order-detail":"ec7734aa","auth":"4a9bacff","community":"ab933900","help":"8c83eee1","sent":"1963ac84","tnc":"e6b30473","welcome":"b0a19bc5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Scan~forget-password~login~reset-password~sign-up~sub-merchant-login":1,"Scan":1,"forget-password":1,"login":1,"reset-password":1,"sent~sign-up":1,"sign-up":1,"sub-merchant-login":1,"brand-Creator":1,"Setting~add-company-intro-template~edit-coupon~edit-notification~edit-sale~home~list-company-intro-t~ef0237b1":1,"Setting":1,"add-company-intro-template":1,"edit-coupon":1,"edit-notification":1,"edit-sale":1,"list-coupons":1,"sub-merchant":1,"list-merchants~list-notification~list-sales~list-statistics~qr-scanner-list-scanned-coupons~qrcode-order":1,"list-merchants":1,"list-notification":1,"list-sales":1,"list-statistics":1,"qr-scanner-list-scanned-coupons":1,"qrcode-order":1,"home":1,"list-company-intro-template":1,"qrcode-order-detail":1,"auth":1,"community":1,"help":1,"sent":1,"tnc":1,"welcome":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Scan~Setting~add-company-intro-template~brand-Creator~edit-coupon~edit-notification~edit-sale~forget~363e6f6e":"Scan~Setting~add-company-intro-template~brand-Creator~edit-coupon~edit-notification~edit-sale~forget~363e6f6e","Scan~Setting~add-company-intro-template~brand-Creator~edit-coupon~edit-notification~edit-sale~forget~fe0fad14":"Scan~Setting~add-company-intro-template~brand-Creator~edit-coupon~edit-notification~edit-sale~forget~fe0fad14","Scan~forget-password~login~reset-password~sign-up~sub-merchant-login":"Scan~forget-password~login~reset-password~sign-up~sub-merchant-login","Scan":"Scan","forget-password":"forget-password","login":"login","reset-password":"reset-password","sent~sign-up":"sent~sign-up","sign-up":"sign-up","sub-merchant-login":"sub-merchant-login","brand-Creator":"brand-Creator","Setting~add-company-intro-template~edit-coupon~edit-notification~edit-sale~home~list-company-intro-t~7c0eb344":"Setting~add-company-intro-template~edit-coupon~edit-notification~edit-sale~home~list-company-intro-t~7c0eb344","Setting~add-company-intro-template~edit-coupon~edit-notification~edit-sale~home~list-company-intro-t~ef0237b1":"Setting~add-company-intro-template~edit-coupon~edit-notification~edit-sale~home~list-company-intro-t~ef0237b1","Setting":"Setting","add-company-intro-template":"add-company-intro-template","edit-coupon":"edit-coupon","edit-notification":"edit-notification","edit-sale":"edit-sale","list-coupons":"list-coupons","sub-merchant":"sub-merchant","list-merchants~list-notification~list-sales~list-statistics~qr-scanner-list-scanned-coupons~qrcode-order":"list-merchants~list-notification~list-sales~list-statistics~qr-scanner-list-scanned-coupons~qrcode-order","list-merchants":"list-merchants","list-notification":"list-notification","list-sales":"list-sales","list-statistics":"list-statistics","qr-scanner-list-scanned-coupons":"qr-scanner-list-scanned-coupons","qrcode-order":"qrcode-order","home":"home","list-company-intro-template":"list-company-intro-template","qrcode-order-detail":"qrcode-order-detail","auth":"auth","community":"community","help":"help","sent":"sent","tnc":"tnc","welcome":"welcome"}[chunkId]||chunkId) + "." + {"Scan~Setting~add-company-intro-template~brand-Creator~edit-coupon~edit-notification~edit-sale~forget~363e6f6e":"31d6cfe0","Scan~Setting~add-company-intro-template~brand-Creator~edit-coupon~edit-notification~edit-sale~forget~fe0fad14":"31d6cfe0","Scan~forget-password~login~reset-password~sign-up~sub-merchant-login":"8b9cf09b","Scan":"9500f288","forget-password":"8ceb95e8","login":"fcea2225","reset-password":"cd3d82e4","sent~sign-up":"56f2e669","sign-up":"f24d1f7d","sub-merchant-login":"bc6a9a06","brand-Creator":"37fec6b7","Setting~add-company-intro-template~edit-coupon~edit-notification~edit-sale~home~list-company-intro-t~7c0eb344":"31d6cfe0","Setting~add-company-intro-template~edit-coupon~edit-notification~edit-sale~home~list-company-intro-t~ef0237b1":"9571326b","Setting":"c7e25fe7","add-company-intro-template":"5973ac29","edit-coupon":"17f892a4","edit-notification":"3547885f","edit-sale":"9d9a4dcc","list-coupons":"303c9937","sub-merchant":"4bd8662d","list-merchants~list-notification~list-sales~list-statistics~qr-scanner-list-scanned-coupons~qrcode-order":"e43f2dc5","list-merchants":"bc253018","list-notification":"8c230c33","list-sales":"e181bcc9","list-statistics":"56887e62","qr-scanner-list-scanned-coupons":"b5381c42","qrcode-order":"80cd2085","home":"49e1a4f8","list-company-intro-template":"caf0d42c","qrcode-order-detail":"23677746","auth":"a2aeed45","community":"29a01dc6","help":"648d6525","sent":"c8a7e19a","tnc":"1f7d11c1","welcome":"79e9437d"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/merchantcenter/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
